import { Expose } from "class-transformer";

export default class CheckPointRes {
  @Expose() readonly point!: number;
}
